fragment sentenceGroupMelodyDetails on SentenceGroupMelodyType {
  id
  description
}
